import { Box, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Dropdown } from "@/components/elements/Dropdown";
import { DropdownItem } from "@/components/elements/Dropdown/types";
import { ConditionsTooltipContent } from "@/components/elements/TooltipContent";

import type { Dispatch, FC, SetStateAction } from "react";

interface Props {
  kpisDisabled: boolean;
  showConditionsTooltip: boolean;
  selectValue: string | undefined;
  dropdownBenchmarks: DropdownItem[];
  setBenchmark: Dispatch<SetStateAction<string | undefined>>;
  currentBenchmark: string | undefined;
}

const ConditionsSelector: FC<Props> = ({
  kpisDisabled,
  showConditionsTooltip,
  selectValue,
  dropdownBenchmarks,
  setBenchmark,
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      label={t("plans.contentLocker.upgradeToAccess")}
      disabled={!kpisDisabled || !showConditionsTooltip}
      withArrow
      events={{ hover: true, focus: true, touch: true }}
      position="top"
      offset={-8}
      maw={300}
      openDelay={100}
      multiline
    >
      <Box>
        <Dropdown
          data={dropdownBenchmarks}
          disabled={kpisDisabled}
          inputProps={{ miw: 200 }}
          label={showConditionsTooltip ? t("components.PerformanceChart.conditions") : undefined}
          tooltip={showConditionsTooltip ? <ConditionsTooltipContent /> : undefined}
          value={selectValue}
          variant="default"
          onChange={(value) => value && setBenchmark(value)}
        />
      </Box>
    </Tooltip>
  );
};

export default ConditionsSelector;
